import { Button, Flex, Text, useDisclosure } from '@chakra-ui/react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ClientFormModal from '../components/Modals/ClientFormModal'
import ResourceFormModal from '../components/Modals/ResourceFormModal'

const Dashboard = () => {
  const { isOpen: clientFormIsOpen, onOpen: openClientForm, onClose: closeClientForm } = useDisclosure()
  const { isOpen: resourceFormIsOpen, onOpen: openResourceForm, onClose: closeResourceForm } = useDisclosure()

  const navigate = useNavigate()

  useEffect(() => {
    navigate('/proposals')
  }, [])

  return (
    <div>
      <Flex alignItems="center" justifyContent="space-between">
        <Text fontSize='3xl'>Dashboard</Text>
        <Flex>
          <Button onClick={openClientForm}>New Client</Button>
          <Button onClick={openResourceForm}>New Resource</Button>
        </Flex>
      </Flex>
      <ClientFormModal
        isOpen={clientFormIsOpen}
        onClose={closeClientForm}
      />
      <ResourceFormModal
        isOpen={resourceFormIsOpen}
        onClose={closeResourceForm}
      />
    </div>
  )
}

export default Dashboard
